export { default } from "./useTeacherLanguagePost";
